import { useEffect } from 'react';

type ScrollSyncProps = {
    elementSelectors: string[]; // Array of class selectors for the elements to sync
    syncHorizontal?: boolean; // Optional param to enable horizontal scroll sync
};

export const useScrollSync = ({ elementSelectors, syncHorizontal = false }: ScrollSyncProps) => {
    useEffect(() => {
        const targetElements: HTMLElement[] = [];

        // Get elements based on the selectors provided
        elementSelectors.forEach((selector) => {
            const elements = document.getElementsByClassName(selector);
            Array.from(elements).forEach((el: Element) => {
                targetElements.push(el as HTMLElement);
            });
        });

        // Scroll synchronization handler
        const handleScroll = (sourceElement: HTMLElement, index: number) => {
            targetElements.forEach((el, i) => {
                if (i !== index) {
                    el.scrollTop = sourceElement.scrollTop; // Sync vertical scroll
                    if (syncHorizontal) {
                        el.scrollLeft = sourceElement.scrollLeft; // Sync horizontal scroll
                    }
                }
            });
        };

        // Attach scroll event listeners to all elements
        targetElements.forEach((element, index) => {
            element.addEventListener('scroll', function () {
                handleScroll(element, index);
            });
        });

        // Cleanup event listeners on component unmount
        return () => {
            targetElements.forEach((element, index) => {
                element.removeEventListener('scroll', function () {
                    handleScroll(element, index);
                });
            });
        };
    }, [elementSelectors, syncHorizontal]);
};
